import { prospectSystemStateMapping as systemStates } from '@scoir/my-colleges/lane-grouping'
import { each, find, includes, reduce } from 'lodash'

const IGNORE_SYSTEM_STATES = [
  systemStates.Start,
  systemStates.Dismissed,
  systemStates.Rejected,
  systemStates.Suggested,
  systemStates.Following,
  systemStates.PendingApplying,
  systemStates.Deleted,
  systemStates.Withdrawn,
]

const OP_SYSTEM_STATES = [
  systemStates.Unknown,
  systemStates.Accepted,
  systemStates.Enrolling,
  systemStates.Denied,
  systemStates.Rescinded,
]

export const bifurcate = (prospects) => {
  return reduce(
    prospects,
    ([nop, op], prospect) => {
      let arr = nop
      if (includes(OP_SYSTEM_STATES, prospect.SystemState)) {
        arr = op
      } else if (includes(IGNORE_SYSTEM_STATES, prospect.SystemState)) {
        arr = []
      }
      arr.push(prospect)
      return [nop, op]
    },
    [[], []],
  )
}

export const NON_COLLEGIATE_OPTIONS = [
  {
    label: 'Delaying enrollment for 1-2 years',
    value: 'GapYear',
    suboutcomes: [
      { label: 'Post-grad to improve chances of athletic recruitment', value: 'GYPostGradAthletic' },
      { label: 'Post-grad to improve acceptance likelihood at a top choice', value: 'GYPostGradTopChoice' },
      { label: 'Internship or other work experience', value: 'GYWorkExp' },
      { label: 'Participation in an educational gap-year program', value: 'GYEducationalProg' },
      { label: 'Religious activities', value: 'GYReligiousActivities' },
      { label: 'Other', value: 'GYOther', freeform: true },
    ],
  },
  { label: 'Workforce', value: 'WorkForce' },
  { label: 'Military', value: 'Military' },
  { label: 'Trade school', value: 'TradeSchool' },
  { label: 'Other', value: 'Other', freeform: true },
]
export const FLAT_NON_COLLEGIATE_OPTIONS = reduce(
  NON_COLLEGIATE_OPTIONS,
  (result, rootOpt) => {
    const newResult = [...result, rootOpt]
    each(rootOpt.suboutcomes, (opt) => {
      newResult.push({ ...opt, parent: rootOpt })
    })
    return newResult
  },
  [],
)

export const hasSelectedAcceptableNonCollegiateOutcome = (outcome) => {
  const outcomeDefinition = find(FLAT_NON_COLLEGIATE_OPTIONS, { value: outcome })
  return outcomeDefinition && !outcomeDefinition.suboutcomes
}
